// removed by extract-text-webpack-plugin
module.exports = {"page-resource-center":"Q5QLFatTBD3jepvEkm_nZ","jumbo":"_6Tyd1BMx16gK3lQmW-B_V","cardWrapper":"_60FdkIlvmnhen0DxFibuY","footer":"_1QGb_4DkeQmtHnnX6TgdKi","pagination":"_2m62IBTbx61BNIFVOsRNjw","nav":"_1Lt3mD_zggZ1Dl4fyHcJUb","nav-item":"MtuJQeMp7KCXFyRouWYPB","nav-link":"_1m9Dd4PvRFE9CK8tfpH6L1","active":"_1tJhPF3DN64HzFT0RR7orI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/MarketingResources/styles.scss
// module id = 569
// module chunks = 1